import { service } from "../utils/request";

// 获取送积分设置
export function getPointSetting(data) {
  return service({
    url: "api/config.point/index",
    method: "post",
    data: data
  });
}

// 设置送积分设置
export function setPointSetting(data) {
  return service({
    url: "api/config.point/setPoint",
    method: "post",
    data: data
  });
}

// 支付场景获取
export function getPayWay(data) {
  return service({
    url: "api/config.point/scene",
    method: "post",
    data: data
  });
}
export function point_config_list(data) {
  return service({
    url: "api/config.point/point_config_list",
    method: "get",
    params: data
  });
}

// 积分抵扣设置获取
export function pointSettingDetail(data) {
  return service({
    url: "api/config.point/detail",
    method: "post",
    data: data
  });
}

// 积分抵扣设置编辑
export function pointSettingEdit(data) {
  return service({
    url: "api/config.point/edit",
    method: "post",
    data: data
  });
}
// 积分抵扣设置
export function point_config_add(data) {
  return service({
    url: "api/config.point/point_config_add",
    method: "post",
    data: data
  });
}
// 积分抵扣详情
export function point_config_detail(data) {
  return service({
    url: "api/config.point/point_config_detail",
    method: "get",
    params: data
  });
}
// 积分抵扣编辑
export function point_config_edit(data) {
  return service({
    url: "api/config.point/point_config_edit",
    method: "post",
    data: data
  });
}
// 积分抵扣删除
export function point_config_del(data) {
  return service({
    url: "api/config.point/point_config_del",
    method: "post",
    data: data
  });
}
// 积分抵扣关闭/开启
export function point_config_disable(data) {
  return service({
    url: "api/config.point/point_config_disable",
    method: "post",
    data: data
  });
}
